import { notification } from '@surecompanies/core_components'
import dayjs from 'dayjs'
import { downloadJSONasCSV } from 'helpers/download-file'
import { ApplicationInfo } from 'types/application'
import { transformApplicationsForCsv } from '../utils/applicationList'

const useExportApplicationsCsv = (
  benefitEffectiveDate: string,
  applications?: ApplicationInfo[]
) => {
  const exportToCsv = () => {
    if (!applications?.length) {
      return
    }

    notification.info({
      message: 'Exporting applications to CSV...',
    })

    const csvData = transformApplicationsForCsv(applications)
    const timestamp = dayjs().format('YYYYMMDDHHmmss')
    const filename = `applications_export_${benefitEffectiveDate}_${timestamp}.csv`

    downloadJSONasCSV(csvData, filename)
  }

  return {
    exportToCsv,
    canExport: applications && applications.length > 0,
  }
}

export default useExportApplicationsCsv
